import axios from "axios";
import api from "../service";
import { ErrorHandler } from "../utils/errorHandler";

/**
 * Centralized service for user details API operations
 */
export class UserDetailsService {

  /**
   * Fetch user details and update component state
   * This is a convenience method that combines fetching and state updating
   * @param {string} requestId - The request ID to fetch details for
   * @param {Object} component - The component instance to update state on
   * @param {string} stateProperty - The state property to update (e.g., 'Advisor', 'checkboxes', 'spokenTo')
   * @param {Object} options - Additional options
   * @param {string} options.componentName - Component name for error context
   * @param {string} options.medium - Survey medium for context
   * @returns {Promise<Object>} - Promise that resolves to the result
   */
  static async fetchAndUpdateState(requestId, component, stateProperty, options = {}) {
    const { componentName = "unknown", medium = "unknown" } = options;

    const config = {
      method: "get",
      url: api.getting_user_details + requestId,
      headers: {},
    };

    try {
      const response = await axios(config);

      // Log success for development
      console.log(`User details fetched successfully for ${componentName}:`, JSON.stringify(response.data));

      // Update component state
      component.setState({
        [stateProperty]: response.data,
      });

      return {
        success: true,
        data: response.data,
        requestId: requestId,
      };
    } catch (error) {
      // Handle error with comprehensive context
      ErrorHandler.handleApiError(error, {
        component: componentName,
        apiEndpoint: api.getting_user_details,
        requestData: config,
        operation: "fetch user details",
        surveyData: {
          requestId: requestId,
          medium: medium,
        },
      });

      return {
        success: false,
        error: error,
        requestId: requestId,
      };
    }
  }
}

export default UserDetailsService;
